import React from "react";
import { useTranslation } from "react-i18next";
import { Body2, Link } from "@activecollab/components";
import { GoogleDrivePreviewIcon } from "~/components/svg";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const GoogleDrivePreview = ({ url }) => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <GoogleDrivePreviewIcon />
          <div className="ang_preview_message">
            <Body2
              className="tw-text-theme-600"
              align="center"
            >
              {t("To view this file, open it in Google Drive.")}
            </Body2>
            <Link
              href={url}
              className="btn btn--pro-2 view_in_google_drive"
              target="_blank"
              rel="noreferrer"
              variant="primary"
            >
              {t("View in Google Drive")}
            </Link>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

GoogleDrivePreview.propTypes = mediaElementShape;
